<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('act')" :class="{'active': section === 'act'}">Akta informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div v-if="section=='act'" class="section">
                    <div class="sectionTitle">Novērtēšanas akta pamatdati</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input type="text" id="act_number" v-model="act_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_date">Akta datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Akta status</label>
                                    <div>
                                        <span class="badge-pill badge-light" v-if="act_status == 'project'">Akta projekts</span>
                                        <span class="badge-pill badge-success" v-if="act_status == 'done'">Novērtēšana pabeigta</span>
                                    </div>
                                </div>
                            </div>
                            <hr>
                          <div class="col-4">
                            <div class="form-group">
                              <label for="commission_decision_nr">Krājuma komisijas lēmuma numurs</label>
                              <input type="text" id="commission_decision_nr" v-model="commission_decision_nr" class="form-control">
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="form-group">
                              <label for="commission_decision_date">Krājuma komisijas lēmuma datums</label>
                              <v-date-picker
                                  :popover="{ visibility: 'click' }"
                                  mode="single"
                                  v-model="commission_decision_date"
                                  :type="'date'"
                                  :locale="'LV'"
                                  color="teal"
                                  :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                              />
                            </div>
                          </div>

                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="section=='items'" class="section">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions">
                            <items-search-component></items-search-component>
                        </div>
                        <div class="fixedHeight">
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Cena</th>
                                <th>Vērtība</th>
                                <th>Jaunā vērtība</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td><span >{{normalFloat(item.price_eur)}}</span></td>
                                <td><span >{{normalFloat(item.price)}}</span></td>
                                <td style="width:150px;">
                                    <input type="number" class="form-control" v-model="item.pivot.item_value">
                                </td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                        ></item-view-component>
                                        <div @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>
                        </div>
                        <hr>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="saveItems()">Saglabāt</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="section">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent text-center">
                        <button class="btn btn-success" @click="evaluateItems()">Veikt novērtēšanu</button>
                        <hr>
                        <a :href="'/evaluation-acts/generate-act/'+id" class="btn btn-primary" target="_blank" >Ģenerēt novērtējuma kopsavilkumu</a>
                        <hr>

                    </div>
                </div>
              <div  class="section">
                <div class="sectionTitle">Exports / Imports</div>
                <div class="sectionContent text-center">
                  <a :href="'/evaluation-acts/export/'+id" class="btn btn-primary" target="_blank" >Eksportēt uz excel</a>
                  <hr>
                  <dropzone v-if="this.url" ref="files"  @vdropzone-success="dropzoneFileSuccess" @vdropzone-error="dropzoneFileError" :useCustomSlot=true :options="{headers:headers,parallelUploads: 1, previewTemplate: template(),url: this.url,maxFilesize: 10, acceptedFiles: ' .xlsx ', thumbnailWidth: 20}" id="file">
                    <div class="dropzone-custom-content">
                      <h3 class="dropzone-custom-title">Atlasīt importa datni</h3>
                    </div>
                  </dropzone>

                </div>
              </div>
                <div v-if="section=='items'" class="section">
                    <div class="sectionTitle">Pievienošana</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12 text-left">
                                <div class="form-group">
                                    <get-from-external-act></get-from-external-act>
                                </div>
                                <div class="form-group">
                                    <get-from-internal-act></get-from-internal-act>
                                </div>
                                <div class="form-group">
                                    <researchers-lists></researchers-lists>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.fixedHeight
{
    max-height:70vh;
    overflow:auto;
    position:relative;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import Dropzone from "vue2-dropzone";
import ItemViewComponent from "../items/ItemViewComponent";
export default{
    components: {ItemViewComponent,Dropzone},
    props:['act','current_user','user'],
    mounted()
    {
        this.items=this.$props.act.items;
        this.id=this.$props.act.id;
        this.act_number=this.$props.act.act_number
        this.act_date=moment(this.$props.act.act_date, moment.ISO_8601)._d;
        this.commission_decision_date=moment(this.$props.act.commission_decision_date, moment.ISO_8601)._d;
        this.commission_decision_nr=this.$props.act.commission_decision_nr;
        this.act_status=this.$props.act.act_status;

        this.url = '/evaluation-acts/import/'+this.id+'/file';
        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            //Should save items data before adding
            that.saveItems().then(() =>
                axios.post('/evaluation-acts/add-item-to-list/'+that.id,
                    {
                        item_id: item_id
                    }).then(response =>{
                    if(response.data.status == 'ok')
                    {
                        that.items = response.data.act.items;
                        that.$toast.open(response.data.message);
                    }
                    if(response.data.status == 'info')
                    {
                        that.$toast.warning(response.data.message);
                    }
                    if(response.data.status == 'error')
                    {
                        that.$toast.warning(response.data.message);
                    }
                }))

        });
        EventBus.$on('add_items_to_list',items_ids =>{
            //Should save items data before adding
            that.saveItems().then(() =>
                axios.post('/evaluation-acts/add-items-to-list/'+that.id,
                    {
                        items_ids: items_ids
                    }).then(response =>{
                    if(response.data.status == 'ok')
                    {
                        that.items = response.data.act.items;
                        that.$toast.open(response.data.message);
                    }
                })
            );
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        changeSection(section)
        {
            this.section = section;
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
        normalFloat(number)
        {
            if(number != null)
            {
                return parseFloat(number).toFixed(2);
            }
            return null;

        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        //Should save informaction before removing
                        that.saveItems(true).then((res) =>
                        {
                            console.log(res);
                            console.log("Sending delete request");
                            axios.post('/evaluation-acts/remove-item-from-list/' + that.id,
                                {
                                    item_id: item_id
                                }).then(response => {
                                if (response.data.status == 'ok') {
                                    that.items = response.data.act.items;
                                    that.$toast.open(response.data.message);
                                }
                                if (response.data.status == 'info') {
                                    that.$toast.warning(response.data.message);
                                }
                                if (response.data.status == 'error') {
                                    that.$toast.error(response.data.message);
                                }
                                console.log("Delete request ended");
                            })
                        }
                    );
                    }});
        },

        evaluateItems()
        {
            var that = this;
            this.saveItems(true).then((res) => {
                console.log(res);
                console.log("Showing evaluate popup");

                that.$swal.fire({
                    title: 'Vai tiešām vēlaties noslēgt priekšmetu novērtēšanu?',
                    text: "Priekšmetu vērtībaas tiks aizpildītas ar novērtējuma aktā esošajām vērtībām.",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#28A745',
                    cancelButtonColor: '#888787',
                    confirmButtonText: 'Veikt novērtēšanu',
                    cancelButtonText: 'Atcelt'
                }).then((result) => {
                    if (result.value) {
                        var that = this;
                        axios.post('/evaluation-acts/evaluate-items/' + that.id, {
                            items: that.items,
                        }).then(response => {
                            if (response.data.status === 'ok') {
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status === 'error') {
                                that.$toast.error(response.data.message);
                            }
                        });
                    }
                });
            });
        },

        async saveItems(showStatus = true)
        {
            var that = this;
            return new Promise((resolve, reject) => {
                axios.post('/evaluation-acts/save-items/'+that.id,{
                    items: that.items,
                }).then(response =>{
                    if(response.data.status === 'ok' && showStatus == true)
                    {
                        that.$toast.open(response.data.message);
                    }
                    if(response.data.status === 'error' && showStatus == true)
                    {
                        that.$toast.error(response.data.message);
                    }
                    return resolve("Dati saglabāti.");
                });
            });

        },
      save()
      {
          var that = this;
          var data = {
              act_number: this.act_number,
              act_date: this.act_date,
              act_status: this.act_status,
              commission_decision_nr: this.commission_decision_nr,
              commission_decision_date: this.commission_decision_date,
          }
          axios.post('/evaluation-acts/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      },
      dropzoneFileSuccess(file, response)
      {
        var that = this;
        if(Array.isArray(this.$refs.files))
        {
          this.$refs.files.forEach(dz => {
            dz.removeFile(file)
          });
        }
        else
        {
          this.$refs.files.removeFile(file);
        }
        this.errors = [];
        this.items=response.act.items;
        this.$toast.open(response.message);

      },
      dropzoneFileError(file, message, xhr)
      {

        this.$toast.open({
          message: "Faila imports neizdevās."+message,
          position: "top-right",
          type:"error",
        });
        if(Array.isArray(this.$refs.files))
        {
          this.$refs.files.forEach(dz => {
            dz.removeFile(file)
          });
        }
        else
        {
          this.$refs.files.removeFile(file);
        }
      },
    },
    data()
    {
        return{
            id:"",
            act_number:"",
            act_date:"",
            act_status:"",
            commission_decision_nr:"",
            commission_decision_date:"",
            items:[],
            loading:false,
            section:"act",
            url:"",
            headers: {
              "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
            },
            template: function () {
              return `<div class="dz-preview dz-file-preview">
                      <div class="dz-details">
                          <div class="dz-filename"><span data-dz-name></span></div>
                          <div class="dz-size"><span data-dz-size></span></div>

                      </div>
                      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                      <div class="dz-error-message"><span data-dz-errormessage></span></div>

                  </div>
              `;
            },

        }
    }


    ,
    computed:{
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
